import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { PagedList, pagedListUtilities } from '../../../common';
import './site-list.scss';

export class SiteList extends Component {
  renderSite(site) {
    const { onUpdate } = this.props;
    return (
      <tr key={site.id}>
        <td>{site.name}</td>
        <td>{site.numTouchpoints}</td>
        <td>
          { site.numTouchpoints <= 0 ? null :
            <button type="button" className="btn btn-primary" onClick={e => onUpdate(site.id)}>
              Update
            </button>
          }
        </td>
      </tr>);
  }

  render() {
    const { sites, sortBy, sortAsc, resultsPerPage, changePageNumber, isFetching, changeSort, loadingMessage } = this.props;

    var siteList = [];
    var currentPage = 1;
    var totalItemsCount = 0;
    if(sites) {
      siteList = sites.results;
      currentPage = sites.currentPage;
      totalItemsCount = sites.totalResults;
    }
    const headerNames = new Map([
      ['name', {
        displayName: 'SITE',
        dataType: 'alpha',
        sortName: 'Site Name' }],
      ['forms', {
        displayName: 'TOUCHPOINTS ACROSS PROGRAMS',
        dataType: 'numeric',
        sortName: 'Number of touchpoints for all programs' }]]);

  const sortText =  pagedListUtilities.getSortText(headerNames, sortBy, sortAsc);
  const sortMessage = " Sites sorted by " + sortText;
  const contentLoadedMessage = "Content Loaded. " + sortMessage;

  const headerColumns = pagedListUtilities.buildSortHeader(headerNames, sortBy, sortAsc, changeSort);
    const headers = (
      <tr>
        {headerColumns}
        <th>ACTION</th>
      </tr>
    );
    return (
      <div id='site-list'>
        <PagedList
          header={headers}
          items={siteList}
          emptyMessage={<p>No Sites Found</p>}
          mapItem={site => this.renderSite(site)}
          currentPage={currentPage}
          resultsPerPage={resultsPerPage}
          totalItemsCount={totalItemsCount}
          changePageNumber={page => changePageNumber(page)}
          isLoading={isFetching}
          loadingMessage={loadingMessage}
          contentLoadedMessage={contentLoadedMessage} />
      </div>
    );
  }
}

SiteList.propTypes = {
  sites: PropTypes.object,
  sortBy: PropTypes.string,
  sortAsc: PropTypes.bool,
  resultsPerPage: PropTypes.number,
  changeSort: PropTypes.func,
  changePageNumber: PropTypes.func,
  onUpdate: PropTypes.func,
  loadingMessage: PropTypes.string,
};

export default SiteList;
